import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { Filters, DataPilot } from '@/modules/data-pilot/types';
import { default_client, default_metrics } from '../services';

export class DataPilotState extends BaseState {
  tags: DataPilot.Tag[] = [];
  models: DataPilot.Model[] = [];
  events: DataPilot.Event[] = [];
  responsible_clients: DataPilot.ResponsibleClient[] = [];
  event_statuses: DataPilot.EventStatus[] = [];
  responsible_events: DataPilot.ResponsibleEvent[] = [];
  priorities: DataPilot.Priority[] = [];
  client_statuses: DataPilot.ClientStatus[] = [];
  product_categories: DataPilot.ProductCategory[] = [];
  marks: DataPilot.Mark[] = [];
  okveds: DataPilot.Okved[] = [];
  regions: string[] = [];
  cities: string[] = [];
  client_categories: DataPilot.ClientCategory[] = [];
  tax_systems: DataPilot.TaxSystem[] = [];

  devices: DataPilot.Device[] = [];

  metrics = default_metrics();

  count_clients = 0;

  client: DataPilot.Client = default_client();

  tab: number | null = null;

  filters: Filters = {
    search: '',
    tag_ids: [],
    event_status_ids: [],
    priority_ids: [],
    period: [],
    event_ids: [],
    client_status_ids: [],
    responsible_client_ids: [],
    responsible_event_ids: [],
    category_ids: [],
    mark_ids: [],
    client_id: null,
  };

  client_events: DataPilot.ClientEvent[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };

  loading = false;
}
